import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { LangProvider } from './context/LangContext';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import MapDetail from './pages/MapDetail';
import MemeStudio from './pages/MemeStudio';
import CreateMap from './pages/CreateMap';
import Auth from './pages/Auth';
import Profile from './pages/Profile';
import Chances from './pages/Chances';

function App() {
  return (
    <AuthProvider>
      <LangProvider>
        <Router>
          <div className="min-h-screen bg-slate-950 flex flex-col">
            <Toaster position="bottom-right" toastOptions={{
              className: 'bg-slate-900 text-white border border-slate-800',
              duration: 3000
            }} />
            <Navbar />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/map/:id" element={<MapDetail />} />
                <Route path="/map/:id/meme" element={<MemeStudio />} />
                <Route path="/create" element={<CreateMap />} />
                <Route path="/login" element={<Auth />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/chances" element={<Chances />} />
              </Routes>
            </main>
          </div>
        </Router>
      </LangProvider>
    </AuthProvider>
  );
}

export default App;